import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { INSURANCE_CLAIMS } from '@ld.consumer-portal/constants';
import { SecureMessageCategory } from '@ld.consumer-portal/models';
import { BrowserService, COMPOSE_MESSAGE_LAUNCHER } from '@ld.consumer-portal/utils';
import { ContactCardComponent } from '../contact-card/contact-card.component';

@Component({
  selector: 'ld-insurance-claims-page',
  imports: [ContactCardComponent, MatIconModule, TranslocoPipe],
  templateUrl: './insurance-claims-page.component.html',
  styleUrl: './insurance-claims-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsuranceClaimsPageComponent {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly browserService = inject(BrowserService);
  private readonly composeMessageLauncher = inject(COMPOSE_MESSAGE_LAUNCHER, { optional: true });

  private readonly accountId = this.route.snapshot.paramMap.get('accountId');

  protected readonly claimProcedurePacketUrl = INSURANCE_CLAIMS.claimProcedurePacketUrl;

  protected readonly faqsLink = computed(() => {
    return this.accountId ? `/help/${this.accountId}/faqs` : '/dashboard';
  });

  protected readonly financialHardshipLink = computed(() => {
    return this.accountId ? `/help/${this.accountId}/financial-hardship` : '/dashboard';
  });

  protected readonly propertyTaxesLink = computed(() => {
    return this.accountId ? `/help/${this.accountId}/property-taxes` : '/dashboard';
  });

  protected readonly homeownersInsuranceLink = computed(() => {
    return this.accountId ? `/help/${this.accountId}/homeowners-insurance` : '/dashboard';
  });

  protected readonly insuranceClaimsLink = computed(() => {
    return this.accountId ? `/help/${this.accountId}/insurance-claims` : '/dashboard';
  });

  openDocument(event: Event, url: string): void {
    event.preventDefault();
    this.browserService.openLocalAsset(url);
  }

  openSecureMessage(): void {
    if (this.composeMessageLauncher) {
      this.composeMessageLauncher({
        category: SecureMessageCategory.InsuranceClaims,
        topic: 'Question',
      }).subscribe();
    } else {
      this.router.navigate(['/dashboard']);
    }
  }
}
